export default Object.freeze({
  DosVecesAlDiaPo10DiasCada10Semanas: 850,
});
